import { useNavigate } from "react-router-dom";
import { Sparkles, Zap, ChevronRight } from "lucide-react";

// Discreet links from Creator Mode to the other two builders.
export default function OtherModeLinks() {
  const navigate = useNavigate();
  const openGenerated = () => {
    try { sessionStorage.setItem("sms_open_generator", "1"); } catch (e) {}
    navigate("/studio");
  };
  const links = [
    { id: "generated", Icon: Sparkles, color: "#8ea2ff", label: "Try Generated Mode", blurb: "We help you build it!", onClick: openGenerated },
    { id: "social", Icon: Zap, color: "#ff8a9a", label: "Try Social Mode", blurb: "Vertical video · 60s · We edit it!", onClick: () => navigate("/minute") },
  ];
  return (
    <div className="mt-3 inline-grid grid-cols-1 gap-2" data-testid="other-mode-links">
      {links.map(({ id, Icon, color, label, blurb, onClick }) => (
        <button key={id} type="button" onClick={onClick} data-testid={`try-${id}-mode-btn`}
          className="group w-full inline-flex items-center justify-center gap-1.5 whitespace-nowrap px-3 py-1.5 rounded-full border border-white/15 bg-white/[0.03] text-xs text-white/70 hover:text-white hover:border-white/35 transition-colors">
          <Icon size={13} style={{ color }} />
          <span className="font-bold" style={{ color }}>{label}</span>
          <span className="text-white">— {blurb}</span>
          <ChevronRight size={13} className="text-white/40 transition-transform group-hover:translate-x-0.5" />
        </button>
      ))}
    </div>
  );
}
